export default __webpack_public_path__ + "static/header-main-0de588d4e7f9f2ed89af3b85400fed89.jpg";